export default "__VITE_ASSET__7b8bcf66__"